<template>
  <v-dialog v-model="dialog" max-width="800px">
    <div class="dialogBackground" :style="isMobile ? '' : 'padding: 80px'">
      <div class="titleText" :style="isMobile ? 'padding: 30px' : ''">
        Claim Prize
      </div>
      <div v-if="fetchingClaim" class="mt-8" style="text-align: center;">
        <v-progress-circular
          :size="70"
          :width="7"
          color="yellow"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-else-if="claimRequest" class="mt-8">
        <div class="subtitleText">
          Your claim request has been received. Thank you for playing Golden
          Moments.
        </div>
        <div>
          <v-btn
            class="yellowButton ma-0 mt-8"
            block
            depressed
            @click="dialog = false"
          >
            Done
          </v-btn>
        </div>
      </div>
      <v-row v-else-if="moment" class="my-8" justify="center" align="center">
        <v-col cols="6">
          <video
            :poster="moment.imageUrl"
            class="videoFrame"
            muted
            autoplay
            loop
          >
            <source :src="moment.videoUrl" type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </v-col>
        <v-col cols="6">
          <div class="challengeName">
            {{ token.collectible.name }}
          </div>
          <div class="challengeTitle">
            {{ moment.name }}
          </div>
        </v-col>
        <v-col cols="12">
          <div>
            <div
              class="divider"
              style="margin-top: 40px; margin-bottom: 40px;"
            />
            <v-row dense>
              <v-col
                v-if="shouldShowPrizeSelection"
                cols="12"
                style="margin-bottom: 16px;"
              >
                <div class="fieldHeader">
                  Prize
                  <span class="required">*</span>
                </div>
                <v-select
                  v-model="note"
                  :items="prizes"
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection="data">
                    <div>
                      <div class="artistName">{{ data.item.artist }}</div>
                      <div class="description">{{ data.item.description }}</div>
                    </div>
                  </template>
                  <template v-slot:item="data">
                    <div>
                      <div class="artistName">{{ data.item.artist }}</div>
                      <div class="description">{{ data.item.description }}</div>
                    </div>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="6">
                <div class="fieldHeader">
                  First Name
                  <span class="required">*</span>
                </div>
                <div>
                  <v-text-field
                    v-model="shippingInfo.firstName"
                    outlined
                    dense
                    hide-details
                  />
                </div>
              </v-col>
              <v-col cols="6">
                <div class="fieldHeader">
                  Last Name
                  <span class="required">*</span>
                </div>
                <div>
                  <v-text-field
                    v-model="shippingInfo.lastName"
                    outlined
                    dense
                    hide-details
                  />
                </div>
              </v-col>
            </v-row>
            <div style="margin-top: 16px;">
              <div class="fieldHeader">
                Address 1
                <span class="required">*</span>
              </div>
              <div>
                <v-text-field
                  v-model="shippingInfo.address1"
                  outlined
                  dense
                  hide-details
                />
              </div>
            </div>
            <div style="margin-top: 16px;">
              <div class="fieldHeader">
                Address 2
              </div>
              <div>
                <v-text-field
                  v-model="shippingInfo.address2"
                  outlined
                  dense
                  hide-details
                />
              </div>
            </div>
            <div style="margin-top: 16px;">
              <div class="fieldHeader">
                Address 3
              </div>
              <div>
                <v-text-field
                  v-model="shippingInfo.address3"
                  outlined
                  dense
                  hide-details
                />
              </div>
            </div>
            <v-row dense style="margin-top: 16px;">
              <v-col cols="6">
                <div class="fieldHeader">
                  Country
                  <span class="required">*</span>
                </div>
                <div>
                  <v-autocomplete
                    v-model="shippingInfo.country"
                    :items="Countries"
                    item-text="name"
                    item-value="name"
                    outlined
                    dense
                    hide-details
                    clearable
                  />
                </div>
              </v-col>
              <v-col cols="6">
                <div class="fieldHeader">
                  State/Province
                  <span class="required">*</span>
                </div>
                <div>
                  <v-text-field
                    v-model="shippingInfo.state"
                    outlined
                    dense
                    hide-details
                  />
                </div>
              </v-col>
            </v-row>
            <v-row dense style="margin-top: 16px;">
              <v-col cols="6">
                <div class="fieldHeader">
                  City
                  <span class="required">*</span>
                </div>
                <div>
                  <v-text-field
                    v-model="shippingInfo.city"
                    outlined
                    dense
                    hide-details
                  />
                </div>
              </v-col>
              <v-col cols="6">
                <div class="fieldHeader">
                  Postal Code
                  <span class="required">*</span>
                </div>
                <div>
                  <v-text-field
                    v-model="shippingInfo.postalCode"
                    outlined
                    dense
                    hide-details
                  />
                </div>
              </v-col>
            </v-row>

            <div style="margin-top: 16px;">
              <div class="fieldHeader">
                Phone Number
                <span class="required">*</span>
              </div>
              <div>
                <v-text-field
                  v-model="shippingInfo.phoneNumber"
                  outlined
                  dense
                  hide-details
                />
              </div>
            </div>

            <div style="margin-top: 16px;">
              <div class="fieldHeader">
                Email Address
                <span class="required">*</span>
              </div>
              <div>
                <v-text-field
                  v-model="shippingInfo.emailAddress"
                  outlined
                  dense
                  hide-details
                />
              </div>
            </div>

            <div class="subtitleText" style="margin-top: 40px;">
              *Please review your shipping information carefully before
              submitting to ensure that all details are accurate and up-to-date!
            </div>
            <div style="margin-top: 40px; text-align: right;">
              <v-btn
                class="yellowButton"
                depressed
                :disabled="!formValidated"
                :loading="loading"
                @click="submit()"
              >
                Submit
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';
  import Countries from '@/assets/countries';
  import ClaimRequestController from '@/controllers/ClaimRequestController';

  export default {
    name: 'CreateTokenListing',

    props: ['token', 'value', 'isMobile'],

    computed: {
      ...mapState({ tokens: (state) => state.tokens }),
      prizes() {
        if (this.moment.rarity === 'instant') {
          return [
            {
              artist: 'BLACK PINK',
              description:
                '1 of BLACKPINK THE GAME PHOTOCARD COLLECTION from No.1~3',
              value: 'black pink',
            },
            {
              artist: 'BTS',
              description: '1 of Official Light Stick Keyring SE',
              value: 'bts',
            },
            {
              artist: 'NewJeans',
              description: 'CHARM SET',
              value: 'newjeans',
            },
            {
              artist: 'Stray Kids',
              description:
                'Stray Kids Mini Album 樂-STAR (ROCK VER., ROLL VER.)',
              value: 'straykids',
            },
            {
              artist: 'IVE',
              description: '(EITHER WAY ver.) IVE THE 1st EP I’VE MINE',
              value: 'ive',
            },
          ];
        } else {
          return [
            {
              artist: 'BLACK PINK',
              description: 'LIGHTSTICK',
              value: 'black pink',
            },
            {
              artist: 'BTS',
              description: 'LIGHTSTICK',
              value: 'bts',
            },
            {
              artist: 'NewJeans',
              description: 'LIGHTSTICK',
              value: 'newjeans',
            },
            {
              artist: 'Stray Kids',
              description: 'LIGHTSTICK',
              value: 'straykids',
            },
            {
              artist: 'IVE',
              description: 'LIGHTSTICK',
              value: 'ive',
            },
          ];
        }
      },
      moment() {
        if (!this.token) {
          return null;
        }
        return this.token.moment;
      },
      claimStatus() {
        return true;
      },
      formValidated() {
        return (
          this.shippingInfo.firstName &&
          this.shippingInfo.lastName &&
          this.shippingInfo.address1 &&
          this.shippingInfo.country &&
          this.shippingInfo.state &&
          this.shippingInfo.city &&
          this.shippingInfo.postalCode &&
          this.shippingInfo.phoneNumber &&
          this.shippingInfo.emailAddress &&
          (this.note || !this.shouldShowPrizeSelection)
        );
      },
      shouldShowPrizeSelection() {
        return this.token.collectible.collectibleId === 'kpopvillage';
      },
    },

    data() {
      return {
        fetchingClaim: false,
        loading: false,
        dialog: this.value,
        shippingInfo: {},
        Countries,
        claimRequest: null,
        note: null,
      };
    },

    watch: {
      value: {
        handler(val) {
          this.dialog = val;
          if (val) {
            this.claimRequest = null;
            this.shippingInfo = {};
            this.note = null;
            this.fetchClaim();
          }
        },
      },
      dialog: function(val) {
        this.$emit('input', val);
      },
    },

    mounted: function() {},

    methods: {
      handleError: function(err) {
        this.$emit('handleError', err);
      },
      fetchClaim: async function() {
        this.fetchingClaim = true;
        try {
          this.claimRequest = await ClaimRequestController.getTokenClaim(
            this.token._id,
            this.shippingInfo
          );
        } catch (error) {
          console.log(error);
        } finally {
          this.fetchingClaim = false;
        }
      },
      submit: async function() {
        this.loading = true;
        try {
          this.claimRequest = await ClaimRequestController.claimToken(
            this.token._id,
            this.shippingInfo,
            this.note
          );
        } catch (error) {
          this.$emit('handleError', error);
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped>
  .dialogBackground {
    background: #ffffff;
    border: 1px solid #9d9d9d;
    border-radius: 30px;
  }
  .titleText {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 40px;
    /* or 100% */

    color: #000000;
  }

  .subtitleText {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 22px;
    /* identical to box height, or 110% */

    color: #000000;
  }

  .challengeName {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #151515 !important;
  }
  .challengeTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    line-height: 32px !important;
    color: #151515 !important;
  }
  .challengeInfo {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    color: #151515 !important;
  }

  .fieldHeader {
    font-family: 'Work Sans' !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 22px !important;
    margin-bottom: 4px !important;
    color: #454c54 !important;
  }

  .artistName {
    font-family: 'Work Sans' !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 22px !important;
    color: #ff8dd8 !important;
    margin-top: 8px;
  }

  .description {
    font-family: 'Work Sans' !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 22px !important;
    color: #454c54 !important;
    margin-bottom: 8px;
  }
</style>
